import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cartItems: [],
  storeProducts: [],
  meta: {},
  productCategories: [],
  ixJCd: ''
};

const slice = createSlice({
  name: 'portalStore',
  initialState,
  reducers: {
    setCartItems: (state, action) => {
      state.cartItems = action.payload ?? [];
    },
    addToCart: (state, action) => {
      const item = action.payload;
      const existingIndex = state.cartItems.findIndex(
        i => i.ixProd === item.ixProd
      );

      if (existingIndex !== -1) {
        state.cartItems[existingIndex].quantity += item.quantity ?? 1;
      } else {
        state.cartItems.push({
          ...item,
          quantity: item.quantity ?? 1
        });
      }
    },
    removeFromCart: (state, action) => {
      const ixProd = action.payload;
      state.cartItems = state.cartItems.filter(item => item.ixProd !== ixProd);
    },
    removeManyFromCart: (state, action) => {
      const idsToRemove = new Set(action.payload); // Set gives O(1) lookups
      state.cartItems = state.cartItems.filter(
        item => !idsToRemove.has(item.ixProd)
      );
    },
    setIxJCd: (state, action) => {
      state.ixJCd = action.payload;
    },
    updateCartQuantity: (state, action) => {
      const { ixProd, newQuantity } = action.payload;
      const item = state.cartItems.find(i => i.ixProd === ixProd);
      if (item) {
        item.quantity = newQuantity;
      }
    },
    clearCart: state => {
      state.cartItems = [];
    },
    setStoreProducts: (state, action) => {
      state.storeProducts = action.payload;
    },
    setProductCategories(state, action) {
      state.productCategories = action.payload;
    },
    setMeta(state, action) {
      state.meta = action.payload;
    }
  }
});

export const {
  setCartItems,
  addToCart,
  removeFromCart,
  removeManyFromCart,
  updateCartQuantity,
  clearCart,
  setStoreProducts,
  setProductCategories,
  setIxJCd,
  setMeta
} = slice.actions;
const portalStoreReducer = slice.reducer;

export default portalStoreReducer;
